import type { SVGProps } from 'react'
const LineFileList = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M13.56 2H4v20h16V8.44zM14 4.56 17.44 8H14zM5.5 20.5v-17h7v4.75c0 .69.56 1.25 1.25 1.25h4.75v11zM11 16v1.5h5.5V16zm-3.5 0h2v1.5h-2zm3.5-3.5V14h5.5v-1.5zm-3.5 0h2V14h-2z"
			clipRule="evenodd"
		/>
	</svg>
)
export { LineFileList }
